import { locales, marketInstanceByLocaleIdentifier } from '@repo/markets/markets'
import { LocaleIdentifier } from '@repo/markets/types'
import { Button, ButtonVariant } from '@repo/ui/components/button'
import { cn } from '@repo/ui/lib/utils'
import { FunctionComponent, MouseEvent } from 'react'

interface Props {
  locale: LocaleIdentifier
  onChange: (newLocale: LocaleIdentifier) => void
  isLoading?: boolean
  showCurrentLocale?: boolean
  buttonVariantCurrentLocale?: ButtonVariant
  buttonVariantOtherLocale?: ButtonVariant
  className?: string
}

const LocaleButtons: FunctionComponent<Props> = ({
  locale,
  isLoading = false,
  showCurrentLocale = true,
  onChange,
  buttonVariantCurrentLocale = 'defaultAuto',
  buttonVariantOtherLocale = 'secondaryAuto',
  className,
}) => {
  const handleChange = (event: MouseEvent<HTMLButtonElement>, newLocale: LocaleIdentifier) => {
    event.preventDefault()
    onChange(newLocale)
  }

  return (
    <ul className={cn('flex gap-px', className)}>
      {locales
        .filter((l) => showCurrentLocale || (!showCurrentLocale && l !== locale))
        .map((l) => (
          <li key={l}>
            <Button variant={l === locale ? buttonVariantCurrentLocale : buttonVariantOtherLocale} onClick={(e) => handleChange(e, l)} disabled={isLoading}>
              {marketInstanceByLocaleIdentifier(l)?.currency?.toUpperCase()}
            </Button>
          </li>
        ))}
    </ul>
  )
}

export default LocaleButtons
